// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phone-dial';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M3.214 1.67h-.008A3.375 3.375 0 0 0 .563 4.967v.668A1.125 1.125 0 0 0 1.688 6.76H4.5a1.125 1.125 0 0 0 1.125-1.125A1.125 1.125 0 0 1 6.75 4.51h4.5a1.13 1.13 0 0 1 1.125 1.125A1.127 1.127 0 0 0 13.5 6.76h2.813a1.125 1.125 0 0 0 1.125-1.125v-.668a3.375 3.375 0 0 0-2.643-3.295h-.009A30.46 30.46 0 0 0 3.214 1.67zM9 10.135a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563m4.219.563a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563m-8.438.563a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563M9 13.51a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563m4.219.563a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563m-8.438.563a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563M9 16.885a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563m4.219.563a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563m-8.438.563a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563'
  />
);

export const viewBox = '0 0 18 18';
